import { render } from "./countdown-page-logo.svg?vue&type=template&id=c89dc2e2"
const script = {}
script.render = render

export default script